// CoveragesForm.jsx
import { useState } from "react"
import "../../css/DemoCode.css"

/**
 * Coverages Form is a group of data inputs usually shown when clicking on Subcatchment->Land Uses. 
 * This form is contained within CoveragesDialog.
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {string} target The name of the node targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function CoveragesForm({ model, setModel, fullModel, target }) {
  const [landUseIDs, setLandUseIDs]   = useState((Object.keys(fullModel.LANDUSES).length===0?[]:Object.keys(fullModel.LANDUSES)))

  // When there is a change to an input element, modify the model.
  const updateValue = (val, type) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ""

    if(model && model.COVERAGES){
      setModel(prev => ({
        ...prev,
        COVERAGES:{
          ...prev.COVERAGES,
          [target]: {
            ...prev.COVERAGES[target],
            [type]: {
              Percent: val
            }
          }
        }
      }))
    }
  }

  if(model){
    return(
      <>
      {
        <>
          {(
            target && 
            target.length > 0 && 
            landUseIDs.map((id)=>(
              <label className='editor-small' key={'CoveragePercent'+target+id}>{id}
                <input  type = "text"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, id)}}
                        value={model.COVERAGES[target][id].Percent}
                        id={'CoveragePercent'+target+id}
                />
              </label>
            ))
          )}
        </>
      }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}